(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.KNBCore = factory());
}(this, (function () { 'use strict';

  /* global navigator document window */

  /**
   * get lower user agent
   *
   * @returns {String} UA
   */
  var canUseBOM = !!(typeof window !== 'undefined' && window.navigator && window.navigator.userAgent);

  function getLowerUserAgent() {
    return canUseBOM ? navigator.userAgent.toLowerCase() : '';
  }

  /**
   * parse user agent into object
   *
   * @param {String} ua
   * @returns {Object} UA
   */
  function parseUserAgent(ua) {
    var uaInfo = {};
    // remove bracket parts & split into pairs
    var uaPairs = ua.replace(/\([^)]+\)/g, '').split(/\s+/);
    var lastItemKey = '';
    for (var i = 0; i < uaPairs.length; i += 1) {
      var item = uaPairs[i];
      var split = item.lastIndexOf('/');
      if (split < 0) lastItemKey = item;else {
        var itemKey = item.slice(0, split);
        if (lastItemKey) {
          itemKey = lastItemKey + ' ' + itemKey;
          lastItemKey = '';
        }
        uaInfo[itemKey] = item.slice(split - item.length + 1);
      }
    }
    return uaInfo;
  }

  /**
   * version format
   *
   * @param {String} version
   * @returns {Interger}
   */
  function formatVersion(version) {
    var safeVersion = version || '0';
    var matches = safeVersion.match(/^(\d*)/);
    return matches ? Number(matches[1]) : 0;
  }

  /**
   * compare version string
   *
   * @param {String} v1
   * @param {String} v2
   * @returns {Boolean}
   */
  function compareVersion(v1, v2) {
    var vs1 = typeof v1 === 'string' ? v1.split('.') : ['0'];
    var vs2 = typeof v2 === 'string' ? v2.split('.') : ['0'];
    var maxTimes = Math.max(vs1.length, vs2.length);
    for (var i = 0; i < maxTimes; i += 1) {
      var n1 = formatVersion(vs1[i]);
      var n2 = formatVersion(vs2[i]);
      if (n1 > n2) return 1;
      if (n1 < n2) return -1;
    }
    return 0;
  }

  /**
   * send message by iframe
   *
   * @param {String} message
   */
  function sendByIframe(message) {
    var timer = -1;
    var node = document.createElement('iframe');
    node.style.display = 'none';
    function removeNode() {
      clearTimeout(timer);
      if (!node) return;
      var pnode = node.parentNode;
      if (pnode) pnode.removeChild(node);
      node.onload = null;
      node.onerror = null;
      node = null;
    }
    node.onload = removeNode;
    node.onerror = removeNode;
    node.src = message;
    document.documentElement.appendChild(node);
    timer = setTimeout(removeNode, 3000);
  }

  /**
   * send message by Android JavascriptInterface
   *
   * @param {String} message
   */
  function sendByInterface(message) {
    if (window.KNBTitansX && window.KNBTitansX.sendMessage) {
      window.KNBTitansX.sendMessage(message);
    } else if (message.length > 10240) {
      throw new Error('too large bridge data');
    } else {
      window.prompt(message);
    }
  }

  /**
   * send message by prompt
   *
   * @param {String} message
   */
  function sendByPrompt(message) {
    if (message.length > 10240) {
      throw new Error('too large bridge data');
    } else {
      window.prompt(message);
    }
  }

  /**
   * get default sender by user-agent
   *
   * @returns {Function}
   */
  function getDefaultSender() {
    var sendMessage = Function.prototype;
    var lowerua = getLowerUserAgent();
    if (/ios|iphone|ipod|ipad/.test(lowerua)) {
      sendMessage = sendByIframe;
    } else if (/android/.test(lowerua)) {
      var uaobject = parseUserAgent(lowerua);
      if (compareVersion(uaobject.android, '4.2.0') > 0) {
        sendMessage = sendByInterface;
      } else {
        sendMessage = sendByPrompt;
      }
    }

    return function defaultSender(method, params, callbackId) {
      var message = 'js://_?method=' + method + '&callbackId=' + callbackId + '&args=' + encodeURIComponent(params);
      sendMessage(message);
    };
  }

  /**
   * TitansX >= 11.13
   *
   */
  function canUseSlot() {
    var lowerua = getLowerUserAgent();
    var uaobject = parseUserAgent(lowerua);
    var version = uaobject.titansx || uaobject.titansnox;
    return compareVersion(version, '11.13') >= 0;
  }

  var defaultSender = {
    getDefaultSender: getDefaultSender,
    compareVersion: compareVersion,
    parseUserAgent: parseUserAgent,
    canUseSlot: canUseSlot()
  };
  var defaultSender_1 = defaultSender.getDefaultSender;
  var defaultSender_2 = defaultSender.compareVersion;
  var defaultSender_3 = defaultSender.parseUserAgent;
  var defaultSender_4 = defaultSender.canUseSlot;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  var INTERNAL = {
    sender: null
  };

  /**
   * merge other slot object
   *
   * @param {Object} source
   * @param {Object} target
   * @returns {Object} result
   */
  function mixin(source, target) {
    if (source && (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object') {
      var result = source;
      Object.keys(target).forEach(function (key) {
        result[key] = target[key];
      });
      return result;
    }
    return target;
  }

  /**
   * get callback id
   *
   * @returns {String} callback id
   */
  function getCallbackId(slot) {
    if (!/^[a-zA-Z0-9]*$/.test(slot)) {
      throw new Error('illegal slot name');
    }
    var random = Math.floor(Math.random() * 1000);
    var timestamp = Date.now().toString().slice(-5);
    return +(timestamp + '' + random) + (slot ? '_' + slot : '');
  }

  /**
   * get callback name
   *
   * @param {String} callbackId
   * @returns {String} callback name
   */
  function getCallbackName(callbackId) {
    // 适配历史版本 KNB 回调逻辑，不要修改
    return 'DPApp_callback_' + callbackId;
  }

  /**
   * fire callback
   *
   * @param {String} callbackId
   * @param {Object} result
   */
  function fireCallback(callbackId, result) {
    var callbackName = getCallbackName(callbackId);
    var callback = window[callbackName];
    if (callback) {
      // 适配历史版本 KNB 回调逻辑，不要修改
      callback(result);
      if (callback.isSafeDelete) window[callbackName] = undefined;
    }
  }

  /**
   * bind DPApp handler
   *
   * @param {String} slotId
   */
  function attachSlot(slot) {
    var safeSlot = slot || 'DPApp';
    if (window[safeSlot] && window[safeSlot].KNBCore) return;
    var slotObject = {
      dequeue: window[safeSlot] && window[safeSlot].dequeue || Function.prototype,
      KNBCore: true,
      callback: fireCallback
    };
    window[safeSlot] = mixin(window[safeSlot], slotObject);
  }

  /**
   * send message
   *
   * @param {String} method
   * @param {Object} params
   * @param {Object} callback
   */
  function sendMessage(method, params, callback, slotId) {
    var slot = defaultSender_4 && slotId ? 'KNBSlot' + slotId : undefined;
    attachSlot(slot);
    var callbackId = getCallbackId(slot);
    var callbackName = getCallbackName(callbackId);
    var safeCallback = callback || {};
    window[callbackName] = function callbackWrap() {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var status = result.status;
      // success = success || 0, fail = fail, handle = action

      var callbackType = status === 'action' ? 'handle' : status;
      if (String(callbackType) === '0') callbackType = 'success';
      // 兼容客户端回调 status 值可能是 cancel 的情况
      if (callbackType !== 'handle' && callbackType !== 'success') callbackType = 'fail';
      var callbackFn = safeCallback[callbackType] || Function.prototype;
      // MTNB use result.data, never support again
      if (typeof callbackFn === 'function') return callbackFn(result);
    };
    if (!safeCallback.handle) window[callbackName].isSafeDelete = true;
    if (INTERNAL.sender) {
      try {
        INTERNAL.sender(method || '', JSON.stringify(params || {}), callbackId);
      } catch (error) {
        console.warn(error.message);
        window[callbackName]({ status: 'fail', errorMsg: error.message, errorCode: 1 });
      }
    }
  }

  /**
   * bind KNBCore handle
   *
   * @param {Object} exports
   */
  function attachGlobal(exports) {
    if (typeof window === 'undefined') return;
    INTERNAL.sender = defaultSender_1();
    if (!window.KNBCore) window.KNBCore = exports;
  }

  /**
   * bind custom sender
   *
   * @param {Function} sender
   */
  function bindSender(sender) {
    if (typeof sender === 'function') {
      INTERNAL.sender = sender;
    }
  }

  var exportObject = {
    bindSender: bindSender,
    sendMessage: sendMessage,
    fireCallback: fireCallback,
    compareVersion: defaultSender_2,
    parseUserAgent: defaultSender_3
  };

  attachGlobal(exportObject);

  return exportObject;

})));
